import { Checkbox } from '@pickleballinc/react-ui';
import { Controller, useFormContext } from 'react-hook-form';

type CheckboxSizeTypes = 'sm' | 'md';

interface CheckboxFormProps {
	name: string;
	label: string;
	size?: CheckboxSizeTypes;
	isDisabled?: boolean;
}

export default function CheckboxForm({ name, label, size = 'sm', isDisabled = false }: CheckboxFormProps) {
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={false}
			render={({ field }) => (
				<Checkbox
					theme="orange"
					{...field}
					className="!size-5 !cursor-pointer !text-lg !font-medium !leading-7 !text-gray-900"
					id={name}
					Text={label}
					size={size}
					disabled={isDisabled}
					checked={field.value}
					onChange={(checked) => {
						field.onChange(checked);
					}}
				/>
			)}
		/>
	);
}
